<template>
  <table v-if="users.length" class="table userList">
    <thead v-if="typeof (admin) !== 'undefined'">
      <tr class="emphasis">
        <th class="badge" :class="admin.userRole">
          <span class="icoUserRole" :data-role="admin.userRole">
            {{admin.userRole}}
            <small>({{admin.sgusername}})</small>
          </span>
        </th>
        <th class="nickname" :data-user="admin.sgusername" :class="{active: focus}" @click="focus = true">
          <input type="text" class="input" v-model="admin.sgnickname" @keyup.enter="updateNickname(admin)" />
          <button type="button" class="btn btnWhite sizeXs" @click="updateNickname(admin)">{{locale.modify}}</button>
        </th>
        <th class="role">
          <UserRole :locale="locale" :value="admin.userRole" disabled />
        </th>
        <th class="date">
          <span v-if="typeof (admin.updateat) !== 'undefined'">
            updated<br>{{date(admin.updateat)}}
          </span>
        </th>
      </tr>
    </thead>
    <tbody v-if="userList.length > 0">
      <Item v-for="item in userList"
        :locale="locale"
        :key="item.sgusername"
        :item="item"
        :inActive="focus"
        @updateNick="updateNickname" />
    </tbody>
  </table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment/moment'
import UserRole from '@/components/Admin/UserRole.vue'
import Item from '@/components/Admin/UserItem.vue'

export default {
  name: 'UserList',
  props: [
    'locale'
  ],
  components: {
    UserRole,
    Item
  },
  computed: {
    ...mapGetters({
      users: 'admin/userList'
    }),
    userList () {
      const list = this.users.filter(x => x.userRole !== 'admin')
      const sortBy = function (key) {
        let result
        switch (key) {
          case 'admin':
            result = 0
            break
          case 'manager':
            result = 1
            break
          case 'staff':
            result = 2
            break
          case 'guest':
            result = 9
            break
        }
        return result
      }
      const sortList = list.sort(function (a, b) {
        return sortBy(a.userRole) - sortBy(b.userRole)
      })
      return sortList
    },
    admin () {
      return this.users.find(x => x.userRole === 'admin')
    }
  },
  created () {
    this.init()
  },
  mounted () {
    document.addEventListener('click', this.active)
  },
  data () {
    return {
      focus: false
    }
  },
  methods: {
    init () {
      this.$store.dispatch('admin/getUserList')
    },
    active (e) {
      const nickname = e.target.closest('.nickname')
      this.focus = nickname !== null && nickname.getAttribute('data-user') === this.admin.sgusername
    },
    date (date) {
      if (typeof (date) !== 'undefined') {
        return moment(date).format('YYYY-MM-DD HH:mm')
      }
    },
    validateNickname (nickname) {
      if (nickname.length <= 1 || nickname.length > 10) {
        alert(this.locale.validate_admin_nickname_length)
        return false
      } else {
        return true
      }
    },
    updateNickname (user) {
      if (this.validateNickname(user.sgnickname)) {
        if (window.confirm(`[${user.sgnickname}] ${this.locale.confirm_modify_nickname}`)) {
          const userName = {
            user: user.sgusername,
            nickname: user.sgnickname
          }
          this.$store.dispatch('admin/updateUserNickname', userName).then(() => {
            this.$store.dispatch('admin/getUserList').then(() => {
              this.$store.dispatch('authentication/getMyAccount').then((res) => {
                this.$store.commit('authentication/updateMyAccount', {sgnickname: res.message.sgnickname})
              })
              alert(this.locale.complete_modify)
              this.focus = false
            })
          })
        }
      }
    }
  }
}
</script>
